// src/pages/MobileLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import { logout as clearAuth, getAccessToken } from "../services/authService";

export default function MobileLogin() {
  const nav = useNavigate();
  useEffect(() => {
    // 以前の管理者トークン等が残っていると、社員ログインしても管理者として扱われることがあるため先に消す
    clearAuth();
  }, []);
  return (
    <LoginForm
      title="社員ログイン"
      accent="#22c55e"
      mode="employee"
      onSuccess={(user) => {
        // 管理者が誤って社員ログインを使ったらブロック（トークンから判定）
        (async () => {
          try {
            const token = getAccessToken();
            // 管理者チェック: admin_me は非管理者で 403 となりコンソールが汚れるため auth/me を使う
            const res = await fetch("/api/auth/me/?_=" + Date.now(), {
              headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            if (res.ok) {
              const me = await res.json();
              if (me.is_staff || me.is_superuser) {
                alert("管理者は管理者用ログインをご使用ください。");
                clearAuth();
                return;
              }
            }
          } catch (_) {
            // ignore（社員ログインの通常経路）
          }
          localStorage.setItem("employeeId", user?.id ?? "");
          nav("/card_front", { replace: true }); // 社員のトップへ
        })();
      }}
    />
  );
}
